import { Outlet, NavLink } from "react-router-dom";

export function ProfilePage() {
    return (
        <>
            <h1>Your Profile</h1>
            <ul className="nav nav-tabs">
                <li className="nav-item">
                    <NavLink to="/profile/configureSource" className="nav-link">
                        <i className="bi bi-cloud-upload me-1"></i>
                        Configure Source Connection
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/profile/configureTarget" className="nav-link">
                        <i className="bi bi-cloud-download me-1"></i>
                        Configure Target Connection
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/profile/dashboard" className="nav-link">
                        <i className="bi bi-speedometer2 me-1"></i>
                        Dashboard
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/profile/mfa-settings" className="nav-link">
                        <i className="bi bi-shield-lock me-1"></i>
                        Security
                    </NavLink>
                </li>
            </ul>
            <Outlet />
        </>
    );
}